import { useSelector, useDispatch } from "react-redux";
import { clear_error as clearGlobalError } from "../../App/actions/errorActions";

// image

// DATA

import { useState } from "react";

function ErrorUI() {
  // const { error, clearError } = useContext(ErrorContext);
  const [isErrorDetail, setIsErrorDetail] = useState(false);

  const global_error = useSelector((state) => state.global_error);
  const dispatch = useDispatch();
  if (Object.keys(global_error).length <= 0) return null;

  const onBack = () => {
    dispatch(clearGlobalError());
    setIsErrorDetail(false);
  };

  const onErrorDetail = () => {
    if (isErrorDetail) {
      setIsErrorDetail(false);
    } else {
      setIsErrorDetail(true);
    }
  };

  return (
    <div
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
        backgroundColor: "rgba(0, 0, 0, 0.5)", // Latar belakang gelap dengan opacity
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        zIndex: 2000, // Pastikan di atas elemen lain
      }}
    >
      <div
        style={{
          width: "25rem",
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          backgroundColor: "white",
          padding: "25px",
          borderRadius: "8px",
          textAlign: "center",
          gap: ".5rem",
        }}
      >
        {isErrorDetail ? (
          <ErrorDetail
            name={global_error?.name}
            message={global_error?.message}
            stack={global_error?.stack}
          ></ErrorDetail>
        ) : (
          <div>
            <h1>Error</h1>
            <p style={{ marginBottom: "1rem" }}>Errod</p>
          </div>
        )}

        <button
          className="button background_red"
          style={{ width: "100%" }}
          onClick={() => onBack()}
        >
          Kembali
        </button>
        <button
          className="button background_black"
          style={{ width: "100%" }}
          onClick={() => onErrorDetail()}
        >
          Error Detail
        </button>
      </div>
    </div>
  );
}

const ErrorDetail = (props) => {
  const { name, message, stack } = props;

  const errorString = "Error: ";
  const avoidStringLength = message?.length + errorString?.length;
  const newStack = stack?.slice(avoidStringLength);
  const stackArray = newStack?.split(" at ");
  stackArray?.shift();

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        gap: "1rem",
        justifyContent: "start",
        alignItems: "start",
        overflowY: "scroll",
        maxHeight: "10rem",
        marginBottom: "1rem",
      }}
    >
      <h2>{name}</h2>
      <p style={{ textAlign: "left", fontSize: ".9rem" }}>{message}</p>
      {stackArray?.map((text, index) => (
        <p
          key={index}
          style={{
            textAlign: "left",
            lineHeight: 1,
            paddingLeft: "2rem",
            fontSize: ".8rem",
          }}
          className="text_grey"
        >
          at {text}
        </p>
      ))}
    </div>
  );
};

export default ErrorUI;
